export default __webpack_public_path__ + "static/media/tenniswarehouse-clashv2.21b0e11c.jpg";